/* v: 2026-05-01-r3 - explicit Buy 2/3 default */
(function() {
  'use strict';

  var BUNDLE_URL = (window.soilifeConfig && window.soilifeConfig.bundleUrl) || '/products/soilife-product-selector';

  var SERVICE_HANDLES = [
    'dna-testing',
    'soil-dna-testing',
    'pot-trial',
    'farm-consultation',
    'custom-microbes-pgpr',
    'soil-microbes-and-feeder',
    'farm-soil-microbes-and-feeder'
  ];

  function isOnSelector() {
    var path = window.location.pathname;
    return path.indexOf('product-selector') !== -1 || path.indexOf('garden-range') !== -1;
  }

  function isServicePage() {
    var path = window.location.pathname;
    /* Farmers collection landing - also a "farmer" surface */
    if (path.indexOf('/collections/farmers-all-products') !== -1) return true;
    if (path.indexOf('/collections/farmers') !== -1) return true;
    for (var i = 0; i < SERVICE_HANDLES.length; i++) {
      if (path.indexOf('/products/' + SERVICE_HANDLES[i]) !== -1) return true;
    }
    return false;
  }

  function renderBar() {
    /* Suppress retail shipping/bundle messaging on farmer surfaces - they have no shipping discount and aren't part of the retail bundle. */
    if (isServicePage()) {
      var existing = document.getElementById('soilife-shipping-bar');
      if (existing) existing.remove();
      return;
    }

    var bar = document.getElementById('soilife-shipping-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'soilife-shipping-bar';
      var header = document.querySelector('.shopify-section-group-header-group, .shopify-section-group-foxify-header-group');
      if (header) {
        header.insertAdjacentElement('afterend', bar);
      } else {
        document.body.insertAdjacentElement('afterbegin', bar);
      }
    }

    var bundleText = 'Buy 2 items \u2192 <strong>6% off</strong> | Buy 3 items \u2192 <strong>12% off</strong>, applied automatically';

    bar.innerHTML =
      '<div class="sl-ship-bar__inner">' +
        '<span class="sl-ship-bar__current">' +
          '\uD83D\uDE9A Use <strong>SHIP40%</strong> to get <strong>40% off shipping</strong> on all your orders!' +
        '</span>' +
        '<span class="sl-ship-bar__sep">|</span>' +
        '<span class="sl-ship-bar__deal">' + bundleText + '</span>' +
      '</div>';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderBar);
  } else {
    renderBar();
  }

  /* LeadConnector booking iframe - let form_embed.js manage height; we only ensure
     it can grow (no inline overflow:hidden) and scrolling isn't blocked. */
  function fixBookingIframes() {
    var iframes = document.querySelectorAll('iframe[src*="leadconnectorhq.com/widget/booking"]');
    iframes.forEach(function(iframe) {
      iframe.style.overflow = 'visible';
      iframe.setAttribute('scrolling', 'auto');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBookingIframes);
  } else {
    fixBookingIframes();
  }
  setTimeout(fixBookingIframes, 1500);
})();
